import { CTA, CTAProps } from '@/components/CTA';
import {
  ExpansionPanelContent,
  ExpansionPanelTrigger,
  ExpansionPanel as MarmaladeExpansionPanel,
} from '@eventbrite/marmalade';
import React from 'react';
import styles from './ExpansionItem.module.scss';

export interface ExpansionItemProps {
  title: string;
  /** Rich Text */
  bodyRichTextAsHTML?: string;
  cta?: CTAProps;
}

export const ExpansionItem: React.FC<ExpansionItemProps> = ({ cta, title, bodyRichTextAsHTML }) => {
  const renderBody = () => {
    if (!bodyRichTextAsHTML) {
      return null;
    }
    return (
      <div
        className={styles.body_rich_text}
        dangerouslySetInnerHTML={{ __html: bodyRichTextAsHTML }}
        suppressHydrationWarning={true}
      />
    );
  };

  return (
    <div className={styles['expansion-item-container']}>
      <MarmaladeExpansionPanel
        variant="default"
        className={styles['expansion-item-main']}
        id="expansion-panel"
        role="region"
        placeholder="Expansion-Panel"
        onPointerEnterCapture={() => {}}
        onPointerLeaveCapture={() => {}}
      >
        <ExpansionPanelTrigger
          className={styles['expansion-item-trigger']}
          id="panel-trigger"
          role="button"
          placeholder="Panel-Trigger"
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
        >
          
        </ExpansionPanelTrigger>
        <ExpansionPanelContent
          className={styles['expansion-item-content']}
          id="panel-content"
          role="region"
          placeholder="Panel-Content"
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
        >
          {renderBody()}
          {cta && <CTA label={cta.label} link={cta.link} type={cta.type} />}
        </ExpansionPanelContent>
      </MarmaladeExpansionPanel>
    </div>
  );
};
